import React from 'react';

export default function Dashboard() {
  return <div>Welcome to Dashboard!</div>;
}
